import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import RequireLoggedIn from "./RequireAuth";

export default function RequireAdmin() {
  const { user } = useAuth();

  // Hergebruik RequireLoggedIn voor de auth-check.
  // Als de gebruiker niet ingelogd is, handelt RequireLoggedIn de redirect af.
  // Hier checken we enkel de admin-rol.
  if (user && user.role?.toUpperCase() !== "ADMIN") {
    return <Navigate to="/" replace />;
  }

  return <RequireLoggedIn />;
}
